import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { MaterialImportDetail } from '../../features/material-imports/material-import-detail';

// No loader: the flag check sits in the component, so a partner without
// `bill_of_materials` gets the panel below rather than a fetch.
export const Route = createFileRoute('/material-imports/$materialImportId')({
  staticData: {
    breadcrumb: 'Material Import',
    layout: 'default',
  },
  component: MaterialImportDetailRoute,
});

function MaterialImportDetailRoute() {
  const { materialImportId } = Route.useParams();
  const { t } = useTranslation('materials');
  const enabled = useFeatureFlag('bill_of_materials');

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">{t('notEnabled.title')}</h2>
        <p className="text-muted-foreground text-sm">{t('notEnabled.body')}</p>
      </div>
    );
  }

  return <MaterialImportDetail materialImportId={materialImportId} />;
}
